import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { buildRegionizeRoute } from '../../../helpers/regionRouteHelper';

export const RegionHandler = () => {
	const navigate = useNavigate();
	useEffect(() => {
		navigate(buildRegionizeRoute(''));
		window.location.reload();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return <></>;
};
